import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '@chama/ui-components/components/Icon';

import './Notification.css';

export default function MapNotification({ text, icon }) {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setFading(true), 4000);
    return () => clearTimeout(timeout);
  }, []);

  const className = classNames('MapNotification__container', { fading });

  return (
    <div className="MapNotification">
      <div className={className}>
        <div className="MapNotification__icon">
          <Icon width={16} height={16} type={icon} iconColor="white" />
        </div>
        <div className="MapNotification__text">{text}</div>
      </div>
    </div>
  );
}
MapNotification.defaultProps = {
  icon: 'checkmark',
};
MapNotification.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string,
};



// WEBPACK FOOTER //
// ../ui-components/components/MapNotifications/components/Notification.jsx